define([
	"dojo/_base/declare",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dijit/_WidgetsInTemplateMixin",
	"csi/types",
	"csi/view/ToolbarPlugin",
	"dojo/text!./timespan.html",
	"dijit/form/Button",
	"csi/widget/Select"
], function(declare,_TemplatedMixin,_WidgetBase,_WidgetsInTemplateMixin,types,ToolbarPlugin,template) {

	return declare([_WidgetBase, _TemplatedMixin, _WidgetsInTemplateMixin, ToolbarPlugin], {
		templateString: template,
		nextNode: null,
		prevNode: null,
		weeksNode: null,

		enablePlugin: function(/*Context?*/ctx) {
			// summary: enable/disable based on context
			this.nextNode.set("disabled", !ctx);
			this.prevNode.set("disabled", !ctx);
			this.weeksNode.set("disabled", !ctx);
		},

		postCreate: function() {
			var self = this;
			var view = this.getView();

			this.inherited(arguments);

			function _updateWeeks(name, oldValue, newValue) {
				// update value on toolbar without triggering onChange event
				self.weeksNode.set("value", String(newValue), false);
			}

			function _updateTooltip() {
				// show date range for tooltip of select node
				if (view.timelineStartDate && view.timelineEndDate) {
					self.weeksNode.set("title", types.getDateRangeString(view.timelineStartDate, view.timelineEndDate));
				}
			}

			view.watch("timelineWeeks", _updateWeeks);
			view.watch("timelineStartDate", _updateTooltip);
			view.watch("timelineEndDate", _updateTooltip);
		},

		_onClickPrev: function() {
			// summary: move time range one week back
			this.getView().set("timelineOffset", this.getView().timelineOffset - 1);
			this.onChange();
		},

		_onClickNext: function() {
			// summary: move time range one week ahead
			this.getView().set("timelineOffset", this.getView().timelineOffset + 1);
			this.onChange();
		},

		_onChangeWeeks: function(/*String*/value) {
			// summary: set new value for weeks
			this.getView().set("timelineWeeks", Number(value));
			this.onChange();
		}
	});
});